import React from 'react';
import FacturaDIANDoc from './FacturaDIANPrint';
import { API_BASE, getContactos } from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');

function getConfigLocal() {
  try { return JSON.parse(localStorage.getItem('erp_empresa') || '{}'); }
  catch { return {}; }
}

function getEmpresa() {
  const cfg = getConfigLocal();
  return {
    nombre: cfg.empresa_nombre || 'ERP INGENIERÍA',
    slogan: cfg.empresa_slogan || 'Soluciones de ingeniería',
    nit:    cfg.empresa_nit    || '',
  };
}

// ── Estilos de impresión inyectados globalmente ───────────────────────────────
const PRINT_CSS = `
@media print {
  body > *:not(#print-root) { display: none !important; }
  #print-root { display: block !important; }
  @page { margin: 15mm; size: A4; }
}
#print-root { display: none; }
`;

if (!document.getElementById('print-style')) {
  const style = document.createElement('style');
  style.id = 'print-style';
  style.textContent = PRINT_CSS;
  document.head.appendChild(style);
}

// ── Plantilla visual PDF/impresión ───────────────────────────────────────────
function DocTemplate({ tipo, numero, fecha, vence, cliente, nit, proyecto, items, subtotal, iva, total, notas, campos, children, cfg: cfgProp }) {
  const cfg = cfgProp || getConfigLocal();
  return (
    <div style={p.page}>
      {/* Encabezado */}
      <div style={p.header}>
        <div>
          <div style={p.docTipo}>{tipo}</div>
          <div style={p.docNumero}>{numero}</div>
        </div>
        <div style={p.headerRight}>
          {(() => {
            return <>
              <div style={p.empresa}>{(cfg.empresa_nombre || 'ERP INGENIERÍA').toUpperCase()}</div>
              {cfg.empresa_slogan && <div style={p.empresaSub}>{cfg.empresa_slogan}</div>}
              {cfg.empresa_nit    && <div style={p.empresaSub}>NIT: {cfg.empresa_nit}</div>}
              {cfg.empresa_direccion && <div style={p.empresaSub}>{cfg.empresa_direccion}</div>}
              {cfg.empresa_ciudad    && <div style={p.empresaSub}>{cfg.empresa_ciudad}</div>}
              {cfg.empresa_telefono  && <div style={p.empresaSub}>Tel: {cfg.empresa_telefono}</div>}
              {cfg.empresa_email     && <div style={p.empresaSub}>{cfg.empresa_email}</div>}
            </>;
          })()}
        </div>
      </div>

      {/* Info cliente + fechas */}
      <div style={p.infoRow}>
        <div style={p.infoBox}>
          <div style={p.infoLabel}>Cliente</div>
          <div style={p.infoVal}>{cliente}</div>
          {nit && <div style={p.infoSub}>NIT: {nit}</div>}
        </div>
        {proyecto && (
          <div style={p.infoBox}>
            <div style={p.infoLabel}>Proyecto</div>
            <div style={p.infoVal}>{proyecto}</div>
          </div>
        )}
        <div style={p.infoBox}>
          <div style={p.infoLabel}>Fecha emisión</div>
          <div style={p.infoVal}>{fecha}</div>
        </div>
        {vence && (
          <div style={p.infoBox}>
            <div style={p.infoLabel}>Vence / Entrega</div>
            <div style={p.infoVal}>{vence}</div>
          </div>
        )}
        {campos && campos.map(c => (
          <div key={c.label} style={p.infoBox}>
            <div style={p.infoLabel}>{c.label}</div>
            <div style={p.infoVal}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Tabla de ítems */}
      {items && items.length > 0 && (
        <table style={p.table}>
          <thead>
            <tr style={p.thead}>
              <th style={p.th}>#</th>
              <th style={p.th}>Descripción</th>
              <th style={{ ...p.th, textAlign:'center' }}>Cant.</th>
              <th style={p.th}>Unidad</th>
              {subtotal !== undefined && <th style={{ ...p.th, textAlign:'right' }}>Precio unit.</th>}
              {subtotal !== undefined && <th style={{ ...p.th, textAlign:'right' }}>Total</th>}
              {subtotal === undefined && <th style={p.th}>Observaciones</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                <td style={p.td}>{i + 1}</td>
                <td style={p.td}>{item.descripcion}</td>
                <td style={{ ...p.td, textAlign:'center' }}>{item.cantidad}</td>
                <td style={p.td}>{item.unidad}</td>
                {subtotal !== undefined && <td style={{ ...p.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>}
                {subtotal !== undefined && <td style={{ ...p.td, textAlign:'right', fontWeight:600 }}>{fmt(item.total_item)}</td>}
                {subtotal === undefined && <td style={p.td}>{item.observaciones || '—'}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Totales */}
      {subtotal !== undefined && (
        <div style={p.totalesWrap}>
          <div style={p.totalRow}><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
          <div style={p.totalRow}><span>IVA (19%)</span><span>{fmt(iva)}</span></div>
          <div style={p.totalFinal}><span>TOTAL</span><span>{fmt(total)}</span></div>
        </div>
      )}

      {/* Contenido adicional */}
      {children}

      {/* Notas */}
      {notas && (
        <div style={p.notas}>
          <strong>Notas:</strong> {notas}
        </div>
      )}

      {/* Firma */}
      <div style={p.firmas}>
        <div style={p.firma}><div style={p.firmaLinea} /><div style={p.firmaLabel}>Elaboró</div></div>
        <div style={p.firma}><div style={p.firmaLinea} /><div style={p.firmaLabel}>Autorizó</div></div>
        <div style={p.firma}><div style={p.firmaLinea} /><div style={p.firmaLabel}>Recibió / Acepta</div></div>
      </div>

      <div style={p.footerDoc}>Documento generado por ERP Ingeniería · {new Date().toLocaleString('es-CO')}</div>
    </div>
  );
}

// ── Hook de impresión ─────────────────────────────────────────────────────────
export function usePrint() {
  return (contenido) => {
    let div = document.getElementById('print-root');
    if (!div) { div = document.createElement('div'); div.id = 'print-root'; document.body.appendChild(div); }
    // Importar ReactDOM dinámicamente para renderizar
    import('react-dom/client').then(({ createRoot }) => {
      const root = createRoot(div);
      root.render(contenido);
      setTimeout(() => { window.print(); }, 600);
    });
  };
}

// ── Botón imprimir + modal correo integrado ───────────────────────────────────
export function BotonesDocumento({ tipo, datos, onEmail, onPrint }) {
  const imprimir = usePrint();

  const defaultPrint = async () => {
    const token = localStorage.getItem('erp_token');

    // Cargar config de empresa desde la API (fuente de verdad)
    let cfg = getConfigLocal();
    try {
      const rc = await fetch(`${API_BASE}/api/configuracion`, { headers: { Authorization: `Bearer ${token}` } });
      if (rc.ok) {
        cfg = await rc.json();
        // Actualizar localStorage para próximas impresiones
        try { localStorage.setItem('erp_empresa', JSON.stringify(cfg)); } catch {}
      }
    } catch {}

    // Para facturas, carga datos completos (ítems + CUFE) si no están disponibles
    let d = datos;
    if (tipo === 'factura' && (!datos.items || !datos.items.length)) {
      try {
        const r = await fetch(`${API_BASE}/api/facturacion/${datos.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        d = await r.json();
      } catch {}
    }
    // Inyectar configuración de empresa en todos los documentos
    d = { ...d, _config: cfg };
    // Generar QR SOLO si el documento fue registrado (aceptado) por la DIAN.
    // El CUFE/QR no se "pegan" hasta que la DIAN lo acepta.
    const registrada = d.estado_fe === 'aceptada';
    const codigoUnico = registrada ? (d.cufe || d.cude) : null;
    if (codigoUnico) {
      try {
        const QRCode = await import('qrcode');
        const qrUrl  = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${codigoUnico}`;
        const qrDataUrl = await QRCode.default.toDataURL(qrUrl, { width: 120, margin: 1, color: { dark:'#000000', light:'#ffffff' } });
        d = { ...d, _qrDataUrl: qrDataUrl };
      } catch {}
    }
    imprimirDoc(d);
  };

  const imprimirDoc = (d) => {
    let doc;
    if (tipo === 'cotizacion') {
      doc = <DocTemplate
        tipo="COTIZACIÓN" numero={d.numero}
        fecha={new Date(d.fecha_emision).toLocaleDateString('es-CO')}
        vence={new Date(d.fecha_vencimiento).toLocaleDateString('es-CO')}
        cliente={d.cliente_nombre} nit={d.nit}
        items={d.items} subtotal={d.subtotal} iva={d.iva} total={d.total}
        notas={d.notas}
        campos={[{ label:'Estado', value: d.estado }]}
        cfg={d._config}
      />;
    } else if (tipo === 'factura') {
      doc = <FacturaDIANDoc datos={d} />;
    } else if (tipo === 'remision') {
      doc = <DocTemplate
        tipo="REMISIÓN DE ENTREGA" numero={d.numero}
        fecha={new Date(d.created_at).toLocaleDateString('es-CO')}
        vence={d.fecha_entrega ? new Date(d.fecha_entrega).toLocaleDateString('es-CO') : null}
        cliente={d.cliente_nombre} proyecto={d.proyecto_nombre}
        items={d.items} notas={d.notas}
        campos={[{ label:'Lugar entrega', value: d.lugar_entrega || '—' }]}
        cfg={d._config}
      />;
    } else if (tipo === 'ot') {
      doc = <DocTemplate
        tipo="ORDEN DE TRABAJO" numero={d.numero}
        fecha={d.fecha_inicio ? new Date(d.fecha_inicio).toLocaleDateString('es-CO') : new Date().toLocaleDateString('es-CO')}
        cliente={d.proyecto_nombre} proyecto={d.proyecto_codigo}
        notas={d.observaciones}
        cfg={d._config}
        campos={[
          { label:'Técnico', value: d.tecnico_nombre || '—' },
          { label:'Prioridad', value: d.prioridad },
          { label:'Estado', value: d.estado },
        ]}
      >
        <div style={{ margin:'16px 0', padding:'14px', background:'#f8fafc', borderRadius:6, border:'1px solid #e2e8f0' }}>
          <strong style={{ display:'block', marginBottom:6, color:'#1e293b' }}>Descripción del trabajo:</strong>
          <p style={{ color:'#334155', margin:0, fontSize:13 }}>{d.descripcion || '—'}</p>
        </div>
      </DocTemplate>;
    }
    imprimir(doc);
  };

  const handlePrint = onPrint || defaultPrint;

  return (
    <div style={{ display:'flex', gap:6 }}>
      <button style={bs.iconBtn} onClick={handlePrint} title="Imprimir / PDF">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
      </button>
      {onEmail && (
        <button style={bs.iconBtnBlue} onClick={onEmail} title="Enviar por correo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        </button>
      )}
    </div>
  );
}

// ── Modal de envío de correo ──────────────────────────────────────────────────
export function ModalEmail({ tipo, id, destinatario, clienteId, onClose, onSent }) {
  const [form, setForm] = React.useState({
    para: destinatario || '',
    cc: '',
    asunto: '',
    mensaje: '',
  });
  const [enviando, setEnviando] = React.useState(false);
  const [resultado, setResultado] = React.useState(null);
  const [contactos, setContactos] = React.useState([]);
  React.useEffect(() => {
    if (clienteId) getContactos(clienteId).then(r => setContactos(r.data || [])).catch(() => {});
  }, [clienteId]);

  const handleEnviar = async () => {
    if (!form.para) return alert('Ingrese el destinatario');
    setEnviando(true);
    try {
      const endpoint = tipo === 'cotizacion'
        ? `${API_BASE}/api/email/cotizaciones/${id}/enviar`
        : tipo === 'remision'
        ? `${API_BASE}/api/email/remisiones/${id}/enviar`
        : `${API_BASE}/api/email/facturas/${id}/enviar`;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('erp_token')}`,
        },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.ok) {
        setResultado({ ok: true, msg: data.mensaje });
        if (onSent) onSent();
      } else {
        setResultado({ ok: false, msg: data.error });
      }
    } catch (e) {
      setResultado({ ok: false, msg: e.message });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={ms.overlay}>
      <div style={ms.modal}>
        <div style={ms.header}>
          <h2 style={ms.title}>✉️ Enviar {tipo === 'cotizacion' ? 'cotización' : tipo === 'remision' ? 'remisión' : 'factura'} por correo</h2>
          <button style={ms.close} onClick={onClose}>✕</button>
        </div>
        <div style={ms.body}>
          {resultado ? (
            <div style={{ textAlign:'center', padding:'24px 0' }}>
              <div style={{ fontSize:48, marginBottom:12 }}>{resultado.ok ? '✅' : '❌'}</div>
              <p style={{ color: resultado.ok ? '#10b981' : '#ef4444', fontWeight:600, fontSize:15 }}>{resultado.msg}</p>
              <button style={ms.btnPrimary} onClick={onClose}>Cerrar</button>
            </div>
          ) : (
            <>
              {contactos.filter(c => c.email).length > 0 && (
                <div style={ms.field}>
                  <label style={ms.label}>Contacto del cliente</label>
                  <select style={ms.input} value={form.para}
                    onChange={e => {
                      const c = contactos.find(x => x.email === e.target.value);
                      setForm({ ...form, para: e.target.value, cc: c && form.cc === '' ? form.cc : form.cc });
                    }}>
                    <option value="">— Elegir contacto —</option>
                    {contactos.filter(c => c.email).map(c => (
                      <option key={c.id} value={c.email}>{c.nombre}{c.cargo ? ` (${c.cargo})` : ''} — {c.email}</option>
                    ))}
                  </select>
                </div>
              )}
              <div style={ms.field}>
                <label style={ms.label}>Para (destinatario) *</label>
                <input style={ms.input} type="email" value={form.para} onChange={e => setForm({...form, para:e.target.value})} placeholder="cliente@empresa.com" />
              </div>
              <div style={ms.field}>
                <label style={ms.label}>CC (copia) — opcional</label>
                <input style={ms.input} type="email" value={form.cc} onChange={e => setForm({...form, cc:e.target.value})} placeholder="otro@empresa.com" />
              </div>
              <div style={ms.field}>
                <label style={ms.label}>Asunto — opcional</label>
                <input style={ms.input} value={form.asunto} onChange={e => setForm({...form, asunto:e.target.value})} placeholder="Se dejará el asunto por defecto si está vacío" />
              </div>
              <div style={ms.field}>
                <label style={ms.label}>Mensaje personalizado — opcional</label>
                <textarea style={{ ...ms.input, minHeight:80, resize:'vertical' }} value={form.mensaje} onChange={e => setForm({...form, mensaje:e.target.value})} placeholder="Estimados señores..." />
              </div>
              <p style={{ color:'#64748b', fontSize:12, marginTop:0 }}>El cuerpo del correo incluirá automáticamente el detalle completo del documento.</p>
              <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:8 }}>
                <button style={ms.btnSecondary} onClick={onClose}>Cancelar</button>
                <button style={{ ...ms.btnPrimary, opacity:enviando?0.7:1 }} onClick={handleEnviar} disabled={enviando}>
                  {enviando ? 'Enviando...' : '✉️ Enviar correo'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Estilos documento impreso ─────────────────────────────────────────────────
const p = {
  page:        { fontFamily:'Arial,sans-serif', fontSize:12, color:'#1e293b', padding:0, maxWidth:800 },
  header:      { display:'flex', justifyContent:'space-between', alignItems:'flex-start', borderBottom:'3px solid #1e3a8a', paddingBottom:16, marginBottom:20 },
  docTipo:     { fontSize:11, color:'#64748b', textTransform:'uppercase', letterSpacing:2, marginBottom:4 },
  docNumero:   { fontSize:24, fontWeight:700, color:'#1e3a8a' },
  headerRight: { textAlign:'right' },
  empresa:     { fontSize:18, fontWeight:700, color:'#1e3a8a' },
  empresaSub:  { fontSize:11, color:'#64748b' },
  infoRow:     { display:'flex', gap:16, marginBottom:20, flexWrap:'wrap' },
  infoBox:     { background:'#f8fafc', borderRadius:6, padding:'10px 14px', border:'1px solid #e2e8f0', minWidth:140, flex:1 },
  infoLabel:   { fontSize:10, color:'#94a3b8', textTransform:'uppercase', letterSpacing:.8, marginBottom:3 },
  infoVal:     { fontSize:13, fontWeight:600, color:'#1e293b' },
  infoSub:     { fontSize:11, color:'#64748b', marginTop:2 },
  table:       { width:'100%', borderCollapse:'collapse', marginBottom:16 },
  thead:       { background:'#1e3a8a' },
  th:          { padding:'10px 12px', color:'#fff', fontSize:11, textAlign:'left', fontWeight:600 },
  td:          { padding:'9px 12px', borderBottom:'1px solid #f1f5f9', fontSize:12 },
  totalesWrap: { display:'flex', flexDirection:'column', alignItems:'flex-end', marginBottom:20 },
  totalRow:    { display:'flex', justifyContent:'space-between', width:220, padding:'4px 0', color:'#64748b', fontSize:12 },
  totalFinal:  { display:'flex', justifyContent:'space-between', width:220, padding:'8px 0', borderTop:'2px solid #1e3a8a', fontWeight:700, fontSize:15, color:'#1e3a8a', marginTop:4 },
  notas:       { background:'#fefce8', borderLeft:'4px solid #fbbf24', padding:'12px 16px', borderRadius:'0 6px 6px 0', fontSize:12, color:'#78350f', marginBottom:20 },
  firmas:      { display:'flex', gap:40, marginTop:40, paddingTop:16 },
  firma:       { flex:1, textAlign:'center' },
  firmaLinea:  { borderTop:'1px solid #94a3b8', marginBottom:6 },
  firmaLabel:  { fontSize:11, color:'#64748b' },
  footerDoc:   { fontSize:10, color:'#94a3b8', textAlign:'center', marginTop:20, borderTop:'1px solid #f1f5f9', paddingTop:10 },
};

const bs = {
  btnPrint: { background:'#334155', color:'#fff', border:'none', borderRadius:8, padding:'9px 18px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnEmail: { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'9px 18px', fontSize:13, fontWeight:600, cursor:'pointer' },
  iconBtn:     { display:'flex', alignItems:'center', justifyContent:'center', width:34, height:34, background:'#1e293b', border:'1px solid #334155', color:'#cbd5e1', borderRadius:8, cursor:'pointer', flexShrink:0 },
  iconBtnBlue: { display:'flex', alignItems:'center', justifyContent:'center', width:34, height:34, background:'#1e293b', border:'1px solid #3b82f6', color:'#93c5fd', borderRadius:8, cursor:'pointer', flexShrink:0 },
};

const ms = {
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:520, border:'1px solid #334155' },
  header:      { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'20px 24px', borderBottom:'1px solid #334155' },
  title:       { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  close:       { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  body:        { padding:'20px 24px' },
  field:       { marginBottom:14 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:5, fontWeight:500 },
  input:       { width:'100%', padding:'9px 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 22px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
};

export default DocTemplate;
